/*
 * @Author: liuhuazhou liuhuazhou@xiaomi.com
 * @Date: 2024-08-19 10:02:18
 * @LastEditors: liuhuazhou liuhuazhou@xiaomi.com
 * @LastEditTime: 2024-08-19 11:21:47
 * @FilePath: /RetailApp/retail-global-h5/src/pages/RetailGlobal/Protocol/PrivacyNotice/id-ID/index.tsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import React, { memo, useEffect } from 'react';
import globalStyles from '../../../../global.less';
import styles from './index.less';

var HTML_CONTENT = ""
HTML_CONTENT += `
    <html>
        <body>
            <div>
                <p style="margin-top:6pt; margin-bottom:6pt; line-height:180%">
                    <span style="font-family:Arial">ご購入前に「Xiaomi Care 利用規約」(<a href="https://www.mi.com/jp/support/terms/xiaomi-care/" style="text-decoration:none"><span style="font-family:Arial; color:#3370ff">https://www.mi.com/jp/support/terms/xiaomi-care/</span></a>)の内容をご確認のうえ、署名してください。</span>
                </p>
                <p style="margin-top:6pt; margin-bottom:6pt; line-height:180%">
                    <span style="font-family:Arial">
                        このメールは、ご予約いただいた商品が店舗に到着した際のご案内としてお送りしています。お受け取りの際に予約情報を確認させていただくため、Xiaomiではお客様の
                        <strong>「お名前」</strong>
                        と
                        <strong>「メールアドレス」</strong>
                        を収集し、本メールアドレス宛に受け取りコードをお送りしています。
                    </span>
                </p>

                <p style="margin-top:6pt; margin-bottom:6pt; line-height:180%">
                    <span style="font-family:Arial">
                        これらの個人情報の取扱いは、
                        <strong>ご契約の履行に必要な範囲で行っております。</strong>
                    </span>
                </p>

                 <p style="margin-top:6pt; margin-bottom:6pt; line-height:180%">
                    <span style="font-family:Arial">
                        **個人情報に関する権利（開示・訂正・削除など）**は、以下のプライバシーサポートプラットフォームより行使いただけます：
                    </span>
                </p>

                <p style="margin-top:6pt; margin-bottom:6pt; line-height:180%">
                    <a href="https://privacy.mi.com/support/" style="text-decoration:none">
                        <span style="font-family:Arial; color:#3370ff">https://privacy.mi.com/support/</span>
                    </a>
                </p>

                <p style="margin-top:6pt; margin-bottom:6pt; line-height:180%">
                    プライバシーポリシーはこちら：
                </p>

                <p style="margin-top:6pt; margin-bottom:6pt; line-height:180%">
                    <a href="https://privacy.mi.com/all/languages/" style="text-decoration:none">
                        <span style="font-family:Arial; color:#3370ff">https://privacy.mi.com/all/languages/</span>
                    </a>
                </p>
            </div>
        </body>
    </html>`;

    
function ProtocolPage() {

    useEffect(() => {
    }, []);

    // 一个用于渲染html的函数组件
    const renderHtml = (html: string) => {
        return <div dangerouslySetInnerHTML={{ __html: html }} />;
    };

    return (
        <div className={[globalStyles['container'], styles['viewport']].join(' ')}>
            {renderHtml(HTML_CONTENT)}
        </div>
    )
}

export default memo(ProtocolPage)